import { useEffect, useMemo } from "react";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import { useLazyGetCitiesQuery } from "@/src-refactor/modules/store/qrtk/services/geoLocation/geoLocation.qrtk";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

type omit = "items";
type MxSelectCityFieldProp = Omit<MxAutoCompleteFieldProps, omit>
const MxSelectCityField = (props: MxSelectCityFieldProp) => {
  const [getCity, { data, isLoading, isUninitialized, isError }] =
    useLazyGetCitiesQuery();

  const Items = useMemo(() => {
    if (!Array.isArray(data?.data)) return [];
    if (isLoading || isUninitialized || isError) return [];
    if (data?.data?.length == 0) return [];
    return data?.data?.map(item => ({
      id: item.id,
      label: item.description,
      value: item.id,
      name: item.description
    })) as I_GENERIC_ITEMS[];
  }, [data, isLoading, isUninitialized, isError]);

  useEffect(() => {
    getCity({
      query: {}
    });
  }, []);

  const onSearch = (value: string) => {
    getCity({
      query: {
        q: value
      }
    });
  };

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={onSearch}
      items={Items}
      loading={isLoading}
    />
  );
};

export default MxSelectCityField;
